import { render } from "./comingsoon_video.vue?vue&type=template&id=4d89eba5"
import script from "./comingsoon_video.vue?vue&type=script&lang=js"
export * from "./comingsoon_video.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__